<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-9 col-xs-9 tabletWidth">
            <div class="col-sm-12 col-xs-12 titleDiv">
              <h3 class="subTitle">{{ isEditMode ? '인증서 시술 수정' : '인증서 시술 등록' }}</h3>
              <h5>{{ isEditMode ? '인증서를 발행할 시술 항목을 수정합니다.' : '인증서를 발행할 시술 항목을 등록합니다.' }}</h5>
            </div>
            <div class="card content-wrap-card col-sm-12 col-xs-12">
              <div class="col-sm-12 col-xs-12 divWrap flex-wrap">
                <div class="col-sm-12 mb100">
                  <div class="col-12 inputDiv">
                    <label for="">진료과목<span class="required-span"/></label>
                      <a-radio-group 
                        v-model:value="medicalDept"
                        class="d-flex flex-wrap radio-div"  
                      >
                        <a-radio v-for="(item, i) in deptList" :key="i" :value="item.code">{{ item.name }}</a-radio>
                      </a-radio-group>
                  </div>
                  <div class="col-12 inputDiv">
                    <label for="">제품분류</label>
                    <a-input
                      class="input-text-common"
                      placeholder="제품분류를 입력하세요" 
                      v-model:value="productType"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap" v-if="medicalDept==='DENT'">
                <div class="col-sm-12 inputDiv">
                  <label for="">제품명<span class="required-span"/></label>
                  <a-select
                    style="width:calc(100% - 150px);"
                    v-model:value="itemBrand"
                    placeholder="제품명을 입력하세요"
                    :default-active-first-option="false" 
                    :options="itemBrandOptions"
                    @input="handleInputItemBrand"
                    show-search
                  ></a-select>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">품목코드<span class="required-span"/></label>
                  <a-input 
                    class="input-text-common" 
                    placeholder="품목코드를 입력하세요" 
                    v-model:value="itemCode" 
                    @input="handleItemCode"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">품목명<span class="required-span"/></label>
                  <a-input 
                    class="input-text-common" 
                    placeholder="품목명을 입력하세요" 
                    v-model:value="itemName" 
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">품목 설명</label>
                  <a-textarea 
                    class="input-textarea-common ant-like-input" 
                    placeholder="품목 설명을 입력하세요" 
                    v-model:value="description" 
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">품목 속성</label>
                  <div class="property-area d-flex">
                    <div 
                      v-for="(item, i) in jsonContents" 
                      :key="i" 
                      class="w-100" 
                      style="margin-bottom: 10px; display: flex; align-items: center;"
                    >
                      <a-input 
                        class="key-input input-text-common"
                        v-model:value="item.propertyName" 
                        placeholder="속성명"  
                        required/>
                      <a-input 
                        class="value-input input-text-common"
                        :class="jsonContents.length > 0 ? '' : 'value-full-width'"
                        type="text" 
                        v-model:value="item.propertyValue"
                        placeholder="값"
                      required/>
                      <a-button v-if="jsonContents.length > 0" 
                        @click="removeItem(i)" 
                        shape="circle"  
                      >
                        <template #icon>
                          <i class="fa-duotone fa-minus"/>
                        </template>
                      </a-button>
                    </div>
                    <a-button  
                      class="add-prop-btn" 
                      @click="addRow"
                    >
                      <template #icon>
                        <i class="fa-solid fa-plus"/> 
                      </template>
                      속성 추가하기
                    </a-button>
                  </div>
                </div>
              </div>
              <!-- 인증서 기본 템플릿 섹션 -->
              <div class="col-sm-12 col-xs-12 template-section">
                <div class="template-section-header">
                  <h4>인증서 기본 템플릿 (옵셔널)</h4>
                  <p class="template-section-desc">입력하시면 병원에서 인증서 발행 시 기본값으로 제공됩니다. 병원에서 자유롭게 수정 가능합니다.</p>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">치료 후 주의사항</label>
                  <a-textarea
                    class="input-textarea-common ant-like-input template-textarea"
                    placeholder="수술 후 2주간 금주, 격렬한 운동 자제 등 환자에게 안내할 주의사항을 입력하세요"
                    v-model:value="defaultAfterSurgery"
                    :rows="4"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">병원 보증사항</label>
                  <a-textarea
                    class="input-textarea-common ant-like-input template-textarea"
                    placeholder="정품 시술 보증, 보증 기간, A/S 정책 등 병원에서 보증하는 내용을 입력하세요"
                    v-model:value="defaultWarranty"
                    :rows="4"
                  />
                </div>
              </div>

              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">무등록발행</label>
                  <div class="d-flex align-items-center">
                    <a-switch v-model:checked="unregisterYn" />
                    <p class="true-color" id="unregister-text">
                      {{ unregisterYn
                        ? '제품 코드가 사전등록되지 않은 경우에도 발행이 가능합니다.'
                        : '제품코드가 사전등록되지 않으면 발행이 불가능합니다.'
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">중복 허용</label>
                  <div class="d-flex align-items-center">
                    <a-switch v-model:checked="duplicateYn" />
                    <p class="true-color" id="duplicate-text">
                      {{ duplicateYn
                      ? '제품코드가 중복되더라도 발행이 가능합니다.'
                      : '제품코드가 중복되는 경우에는 발행이 불가능합니다.'
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">인증서 이미지<span class="required-span"/></label>
                  <div class="file-input-wrap">
                    <input
                      type="file"
                      accept="image/jpeg, image/png, image/gif"
                      @change="changeLogoImage"
                      id="fileInput"
                      ref="fileInput"
                    />
                    <div class="file-relative-wrap">
                      <a-input 
                      class="input-text-common file-name-input" 
                      placeholder="이미지를 등록하세요"
                      readonly
                      v-model:value="fileName"
                      />
                      <div  v-if="fileName || fileData" class="download-wrap" @click="downloadLogoImage()">
                        <i class="fa-solid fa-down-to-bracket"/>
                      </div>
                      <a-button 
                        class="black no-radius-left no-radius-right img-add-btn"
                        @click="clickFileInput"
                      >
                      등록/수정
                      </a-button>
                    </div>
                    <a-button @click="deleteImage">
                      삭제
                    </a-button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv"  style="margin-bottom: 0px !important;">
                  <label />
                  <div class="img-desc">
                    <ul style="padding-left: 1rem;">
                      <li>
                        이미지 사이즈 : 850×1348px
                      </li>
                      <li>
                        확장자 : PNG, JPG, JPEG, GIF
                      </li>
                      <li>
                        파일크기 : 최대 100MB까지
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">NFT 배경색<span class="required-span"/></label>
                  <div class="d-flex align-items-center colorPicker">
                    <color-picker v-model:pureColor="pureColor" />
                    <a-input class="d-none" id="rgbaInput" v-model:value="pureColor" @input="convertToHex"/>
                    <p class="true-color2">{{ hexValue }}</p>
                  </div>
                </div>
              </div>
              <!-- 시술 태그 이미지 섹션 -->
              <div class="col-sm-12 col-xs-12 template-section">
                <div class="template-section-header">
                  <h4>시술 태그 이미지 (옵셔널)</h4>
                  <p class="template-section-desc">병원 목록에서 해당 시술 태그로 표시될 이미지입니다. 등록하지 않으면 텍스트로 표시됩니다.</p>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">태그 이미지</label>
                  <div class="file-input-wrap">
                    <input
                      type="file"
                      accept="image/svg+xml, image/png, image/jpeg, image/gif"
                      @change="changeTagImage"
                      id="tagFileInput"
                      ref="tagFileInput"
                    />
                    <div class="file-relative-wrap">
                      <a-input
                        class="input-text-common file-name-input"
                        placeholder="태그 이미지를 등록하세요"
                        readonly
                        v-model:value="tagFileName"
                      />
                      <div v-if="tagFileName || tagFileData" class="download-wrap" @click="downloadTagImage()">
                        <i class="fa-solid fa-down-to-bracket"/>
                      </div>
                      <a-button
                        class="black no-radius-left no-radius-right img-add-btn"
                        @click="clickTagFileInput"
                      >
                        등록/수정
                      </a-button>
                    </div>
                    <a-button @click="deleteTagImage">
                      삭제
                    </a-button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv" style="margin-bottom: 0px !important;">
                  <label />
                  <div class="img-desc">
                    <ul style="padding-left: 1rem;">
                      <li>
                        권장 사이즈 : 28×14px (2:1 비율)
                      </li>
                      <li>
                        확장자 : SVG, PNG, JPG, JPEG, GIF
                      </li>
                      <li>
                        파일크기 : 최대 5MB까지
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap" v-if="hasTagImage && tagImageUrl">
                <div class="col-sm-12 inputDiv">
                  <label for="">태그 미리보기</label>
                  <div class="tag-preview-wrap">
                    <img :src="tagImageUrl" alt="태그 이미지 미리보기" class="tag-preview-image" />
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 d-flex flex-wrap">
                <div class="col-sm-12 inputDiv">
                  <label for="">태그 표시 순서</label>
                  <div class="d-flex align-items-center" style="gap: 12px;">
                    <a-input-number
                      v-model:value="displayOrder"
                      :min="0"
                      :max="999"
                      placeholder="100"
                      style="width: 120px;"
                    />
                    <span class="display-order-hint">낮을수록 먼저 표시됩니다 (기본값: 100)</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex item-btn-area">
              <a-button
              class="certi-cancel-btn"
                @click="handleCancel"
                >
                <p>취소</p>
              </a-button>
              <a-button
                type="primary"
                @click="uploadImgAndData"
                class="certi-submit-btn"
                >
                <p>{{ isEditMode ? '시술 수정하기' : '시술 등록하기' }}</p>
              </a-button>
            </div>

          </div>
          <div class="col-3 phone-preview-wrap" ref="phone-preview-wrap">
            <div class="island" style="">
              <img src="../assets/img/phoneEye.png" alt="" />
            </div>
            <div class="col-sm-12 phoneBg" :style="hexValue.length > 0
                ? 'background-color:' +
                hexValue
                : 'background-color:#F1F2F3'
              ">
              <div class="imgDiv">
                <img ref="prevImg" id="prevImg" :src="hasImage
                    ? certificateImgUrl
                    : 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png'
                  " 
                  alt="" />
              </div>
              <div class="col-sm-12 phoneText">
                <em />
                <div class="certTitle" :class="{ open: isOpen }">
                  <h4>
                    {{ itemName.length > 0 ? itemName : 'CERTILIFE' }}
                  </h4>
                  <p>{{ description }}</p>
                  <p>
                    병원에서 추가적으로 작성하는 부분입니다.
                  </p>
                </div>
                <button class="overflowBtn" type="button" @click="toggleOverflow" :class="{ clicked: isClicked }">
                  <img src="../assets/img/rightGray.png" alt="" />
                </button>
                <div class="cert_info">
                  <h4>상세정보</h4>
                  <table>
                    <tr>
                      <td class="head">브랜드</td>
                      <td>{{ brand }}</td>
                    </tr>
                    <tr v-if="jsonContents.length > 0 && 
                      (jsonContents[0].propertyName || 
                      jsonContents[0].propertyValue)" 
                      v-for="(item, i) in jsonContents">
                      <td class="head">{{ item.propertyName }}</td>
                      <td>{{ item.propertyValue }}</td>
                    </tr>
                    <tr>
                      <td class="head">수술일자</td>
                      <td>{{ convertDate(Date()) }}</td>
                    </tr>
                    <tr v-if="convertMedicalDept(medicalDept)">
                      <td class="head">진료과목</td>
                      <td>{{ convertMedicalDept(medicalDept) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="cert_info">
                  <h4>받은 내역</h4>
                  <table>
                    <tr>
                      <td class="head">발행 시각</td>
                      <td>{{ convertDate(Date()) }}</td>
                    </tr>
                    <tr>
                      <td class="head">보낸 사람</td>
                      <td>자체 발행</td>
                    </tr>
                    <tr>
                      <td class="head">트랜잭션 해시</td>
                      <td>
                        <button type="button">
                          <input type="text" value="0x4f2a7d8e...b5123d4887" readonly disabled />
                          <i class="fa-regular fa-copy" />
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import {
  changeBytesToKilos,
  oneBtnDialog,
  boolToYn,
  convertYnToBool,
} from '@/utils/utils';
import { convertMedicalDept, MedicalDept } from '@/utils/enums';
export default {
  name: 'AddItem',
  components: { ColorPicker },
  data() {
    return {
      brand: '',
      medicalDept: '', // 과
      companyInfo: JSON.parse(localStorage.getItem('CompanyInfo')),
      convertMedicalDept: convertMedicalDept,
      productType: '', // 제품분류
      unregisterYn: false, // 무등록 발행
      itemBrand: '', // 브랜드 명
      itemCode: '', // 품목 코드
      itemName: '', // 품목명
      description: '', // 품목명
      duplicateYn: false, // 중복 허용
      fileName: '', // 이미지 파일명
      fileData: null, // 실제 파일 정보가 담긴 폼데이터
      certificateImgUrl: '', // objectStorage 상 이미지 url
      hasImage: false,

      background_color: null, // NFT배경색
      deptList: [], // 과 목록
      jsonContents: [
        {
          propertyName: '',
          propertyValue: '',
        },
      ],
      pureColor: 'rgb(255, 255, 255)',
      hexValue:'',
      hasRequested: false,
      isOpen: false,
      isClicked: false,
      itemBrandOptions:[],

      // 수정 모드 관련
      isEditMode: false,
      itemId: null,

      // 인증서 기본 템플릿
      defaultAfterSurgery: '', // 기본 치료 후 주의사항
      defaultWarranty: '', // 기본 병원 보증사항

      // 시술 태그 이미지
      tagImageUrl: '', // 태그 이미지 URL
      tagFileName: '', // 태그 이미지 파일명
      tagFileData: null, // 태그 이미지 파일 데이터
      hasTagImage: false, // 태그 이미지 존재 여부

      // 태그 표시 순서
      displayOrder: 100, // 태그 표시 순서 (낮을수록 먼저 표시)
    };
  },
  beforeUnmount() {
  },
  // rgba코드 hex코드로 바꾸기
  watch: {
    pureColor(newValue) {
      this.convertToHex();
    },
  },
  // rgba코드 hex코드로 바꾸기
  async mounted() {
    this.brand = localStorage.getItem('companyManu') ? localStorage.getItem('companyManu') : '제조사';
    this.convertToHex(); // 초기 Hex 값
    await this.getDeptList();
    this.itemBrandOptions = await this.getDentItemStepOne()
    this.itemBrandOptions = this.itemBrandOptions.map(i=>{
      return {
        label:i.brand,
        value:i.brand,
      }
    });

    // 수정 모드 체크
    if (this.$route.params.itemId) {
      this.isEditMode = true;
      this.itemId = this.$route.params.itemId;
      await this.loadItemData();
    }
  },
  methods: {
    handleInputItemBrand(event){
      this.itemBrand = event.target.value;
    },

    // 취소 버튼 핸들러 - 인증서 시술 등록 목록으로 이동
    handleCancel() {
      this.$router.push('/certificate-surgery/registration');
    },

    // 수정 모드: 기존 데이터 로드
    async loadItemData() {
      try {
        const response = await this.$apiInstance.get(`/items/${this.itemId}`);
        if (response.status === 200 || response.status === 201) {
          const { data } = response;

          this.medicalDept = data.medicalDept;
          this.productType = data.productType || '';
          this.itemBrand = data.brand || '';
          this.itemCode = data.itemCode || '';
          this.itemName = data.itemName || '';
          if (data.description) this.description = data.description;
          if (data.background_color) {
            this.background_color = data.background_color;
            this.pureColor = data.background_color;
            this.hexValue = data.background_color;
          }

          this.duplicateYn = convertYnToBool(data.duplicateYn);
          this.unregisterYn = convertYnToBool(data.unregisterYn);

          if (data.certificateImgUrl) {
            this.certificateImgUrl = data.certificateImgUrl;
            const fileNameArray = data.certificateImgUrl.split('/');
            this.fileName = fileNameArray[fileNameArray.length - 1];
            this.hasImage = true;
          }

          this.jsonContents = [];
          if (data.jsonContents) {
            const jsonObj = JSON.parse(data.jsonContents);
            for (let i = 0; i < jsonObj.length; i++) {
              this.jsonContents.push({
                propertyName: Object.keys(jsonObj[i])[0],
                propertyValue: Object.values(jsonObj[i])[0],
              });
            }
          }
          if (this.jsonContents.length === 0) {
            this.jsonContents = [{ propertyName: '', propertyValue: '' }];
          }

          // 인증서 기본 템플릿 로드
          if (data.defaultAfterSurgery) this.defaultAfterSurgery = data.defaultAfterSurgery;
          if (data.defaultWarranty) this.defaultWarranty = data.defaultWarranty;

          // 시술 태그 이미지 로드
          if (data.tagImageUrl) {
            this.tagImageUrl = data.tagImageUrl;
            const tagFileNameArray = data.tagImageUrl.split('/');
            this.tagFileName = tagFileNameArray[tagFileNameArray.length - 1];
            this.hasTagImage = true;
          }

          // 태그 표시 순서 로드
          this.displayOrder = data.displayOrder ?? 100;
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog('데이터 로드 실패', '데이터를 가져오는 중 오류가 발생했습니다.', false);
        this.$router.push('/certificate-surgery/registration');
      }
    },
    

    /* 
      
    클릭클릭 제조사 정보 가져오기(치아 선택 시에 바인딩)

      고민: 거의 고정값이므로 페이지 로드 시에 1회만 호출? 치아 선택 마다 호출?

    */
    async getDentItemStepOne() {
      const obj = {};
      obj.manufacturer = this.$route.query.companyName;

      let resultCompanies = [];
      try {
        const response = await this.$apiInstance.post(`/items/dent/2`, obj);
        if (response.status === 200 || response.status === 201) {
          if(response.data) resultCompanies = response.data;
        }
      } catch(error) {
        console.log(error);
        await oneBtnDialog('품목 가져오기 실패', '품목 가져오기에 실패했습니다.', false);
      } finally {
        return resultCompanies;
      }
    },

    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog('진료 과목 로드 실패','진료 과목 로드에 실패하였습니다.', false);
      }
    },
    handleItemCode(event) {
      let inputValue = event.target.value;
      const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]*$/;
      if (!regex.test(inputValue)) {
          event.target.value = inputValue.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]/g, '');
      }
    },
    async validateData() {
      let result = true;
      const hexRegex = /^#([0-9a-fA-F]{3}){1,2}$/;

      if(!this.medicalDept) {
        result = false;
        oneBtnDialog('진료 과목 미선택', '진료 과목을 선택해 주세요.', false);
        return result;
      } else if (this.medicalDept === 'DENT' && !this.itemBrand) {
        // 제품명은 치과(DENT)일 때만 필수
        result = false;
        oneBtnDialog('제품명 미입력', '제품명을 입력해 주세요.', false);
        return result;
      } else if (!this.itemCode) {
        result = false;
        oneBtnDialog('품목코드 미입력', '품목코드를 입력해 주세요.', false);
        return result;
      } else if (!this.itemName) {
        result = false;
        oneBtnDialog('품목명 미입력', '품목명을 입력해 주세요.', false);
        return result;
      } else if (!this.certificateImgUrl && (!this.fileName || !this.fileData)) {
        result = false;
        oneBtnDialog('인증서 이미지 업로드', '인증서 이미지를 업로드해 주세요.', false);
        return result;
      } else if (this.background_color && !hexRegex.test(this.background_color)) {
        result = false;
        oneBtnDialog('색상 코드 오류', '유효하지 않은 색상 코드입니다.', false);
        return result;
      } 
      return result;
    },
    // 이미지와 데이터 업로드 및 후처리
    async uploadImgAndData() {
      if (await this.validateData()) {
        if(!this.hasRequested) {
          this.hasRequested = true;
          await this.uploadImage();
          await this.uploadTagImage(); // 태그 이미지 업로드
          if (this.certificateImgUrl !== '') {
            if (this.isEditMode) {
              await this.updateItem();
              await oneBtnDialog('시술 수정 완료', '시술 수정이 완료되었습니다.', true);
            } else {
              await this.registerItem();
              await oneBtnDialog('시술 등록 완료', '시술 등록이 완료되었습니다.', true);
            }
            this.$router.push('/certificate-surgery/registration');
          }
        }
      }
    },
    
    // 이미지 오브젝트스토리지에 업로드
    async uploadImage() {
      if (this.fileData) {
        try {
          const response = await this.$apiInstance.post(`/object-storages`, this.fileData);
          if (response.status === 200 || response.status === 201) {
            this.certificateImgUrl = response.data.url;
          }
        } catch (error) {
          console.log(error);
          await oneBtnDialog('품목 등록 실패', '품목 등록에 실패하였습니다.', false);
          this.hasRequested = false;
        }
      } else {
      }
    },

    // 데이터 서버에 전송
    async registerItem() {
      
      const obj = {};
      obj.medicalDept = this.medicalDept;
      obj.productType = this.productType;
      obj.itemName = this.itemName;
      obj.companyName = this.$route.query.companyName;
      obj.brand = this.itemBrand;
      obj.itemCode = this.itemCode;
      obj.unregisterYn = boolToYn(this.unregisterYn);
      obj.duplicateYn = boolToYn(this.duplicateYn);
      obj.certificateImgUrl = this.certificateImgUrl;
      if(this.description) obj.description = this.description;
      if(this.background_color && this.background_color !== '') obj.background_color = this.background_color;

      // 인증서 기본 템플릿 (옵셔널)
      if (this.defaultAfterSurgery) obj.defaultAfterSurgery = this.defaultAfterSurgery;
      if (this.defaultWarranty) obj.defaultWarranty = this.defaultWarranty;

      // 시술 태그 이미지 (옵셔널)
      if (this.tagImageUrl) obj.tagImageUrl = this.tagImageUrl;

      // 태그 표시 순서
      obj.displayOrder = this.displayOrder ?? 100;

      const newJsonContents = new Array();
      this.jsonContents.forEach((element) => {
        if (element.propertyName && element.propertyValue) {
          const newObject = {};
          newObject[element.propertyName] = element.propertyValue;
          if(!obj.itemSpec){
            obj.itemSpec =element.propertyValue
          }
          newJsonContents.push(newObject);
        }
      });
      if (newJsonContents.length > 0) {
        obj.jsonContents = JSON.stringify(newJsonContents);
      } else {
        obj.jsonContents = '';
      }
      try {
        const response = await this.$apiInstance.post(`/items/by-company-name`, obj);
        if (response.status === 200 || response.status === 201) {

        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog('품목 등록 실패', '품목 등록에 실패하였습니다.', false);
        this.hasRequested = false;
      }
    },

    // 데이터 서버에 수정 전송
    async updateItem() {
      const obj = {};
      obj.medicalDept = this.medicalDept;
      obj.productType = this.productType || '';
      obj.itemName = this.itemName;
      obj.brand = this.itemBrand;
      obj.itemCode = this.itemCode;
      obj.unregisterYn = boolToYn(this.unregisterYn);
      obj.duplicateYn = boolToYn(this.duplicateYn);
      obj.certificateImgUrl = this.certificateImgUrl;
      obj.description = this.description || '';
      if (this.background_color && this.background_color !== '') {
        obj.background_color = this.background_color;
      }

      // 인증서 기본 템플릿 (옵셔널 - 빈 값도 허용하여 기존 값 삭제 가능)
      obj.defaultAfterSurgery = this.defaultAfterSurgery || '';
      obj.defaultWarranty = this.defaultWarranty || '';

      // 시술 태그 이미지 (옵셔널 - 빈 값도 허용하여 기존 값 삭제 가능)
      obj.tagImageUrl = this.tagImageUrl || '';

      // 태그 표시 순서
      obj.displayOrder = this.displayOrder ?? 100;

      const newJsonContents = new Array();
      this.jsonContents.forEach((element) => {
        if (element.propertyName && element.propertyValue) {
          const newObject = {};
          newObject[element.propertyName] = element.propertyValue;
          if (!obj.itemSpec) {
            obj.itemSpec = element.propertyValue;
          }
          newJsonContents.push(newObject);
        }
      });
      if (newJsonContents.length > 0) {
        obj.jsonContents = JSON.stringify(newJsonContents);
      } else {
        obj.jsonContents = '';
      }

      try {
        await this.$apiInstance.put(`/items/${this.itemId}`, obj);
      } catch (error) {
        console.log(error);
        await oneBtnDialog('품목 수정 실패', '품목 수정에 실패하였습니다.', false);
        this.hasRequested = false;
      }
    },

    // 속성 줄 추가
    addRow() {
      const propertyObj = {
        propertyName: '',
        propertyValue: '',
      }
      this.jsonContents.push(propertyObj);
    },
    removeItem(index) {
      this.jsonContents.splice(index, 1);
    },
    deleteImage() {
      this.fileData = null;
      this.fileName = '';
      this.certificateImgUrl = '';
      this.hasImage = false;
      this.$refs.prevImg.src = 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png';
    },
    async clickFileInput() {
      let fileInput = document.getElementById('fileInput');
      fileInput.click();
    },
     // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/gif' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }

      return result;
    },
    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = this.$refs.fileInput;
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            this.hasImage = true;
            document.getElementById('prevImg').src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.fileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.fileData = formData;
        }
      }
    },
    downloadLogoImage() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.certificateImgUrl;
        downloadLink.download = this.fileName;
        downloadLink.click();
      }
    },

    // 태그 이미지 관련 메소드
    clickTagFileInput() {
      let tagFileInput = document.getElementById('tagFileInput');
      tagFileInput.click();
    },
    validateTagFile(file) {
      let result = true;
      const validTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
      if (!validTypes.includes(file.type)) {
        alert('svg, png, jpeg, jpg, gif 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 5) {
        alert('파일 크기가 5MB를 초과합니다.');
        result = false;
      }
      return result;
    },
    changeTagImage() {
      const tagFileInput = this.$refs.tagFileInput;
      if (tagFileInput.files && tagFileInput.files[0]) {
        const validateFile = this.validateTagFile(tagFileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          const self = this;
          reader.onload = function (e) {
            self.hasTagImage = true;
            self.tagImageUrl = e.target.result;
          };
          reader.readAsDataURL(tagFileInput.files[0]);
          this.tagFileName = tagFileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', tagFileInput.files[0]);
          this.tagFileData = formData;
        }
      }
    },
    deleteTagImage() {
      this.tagFileData = null;
      this.tagFileName = '';
      this.tagImageUrl = '';
      this.hasTagImage = false;
      if (this.$refs.tagFileInput) {
        this.$refs.tagFileInput.value = '';
      }
    },
    downloadTagImage() {
      const tagFileInput = this.$refs.tagFileInput;
      const file = tagFileInput?.files?.[0];
      if (file) {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else if (this.tagImageUrl) {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.tagImageUrl;
        downloadLink.download = this.tagFileName;
        downloadLink.click();
      }
    },
    async uploadTagImage() {
      if (this.tagFileData) {
        try {
          const response = await this.$apiInstance.post(`/object-storages`, this.tagFileData);
          if (response.status === 200 || response.status === 201) {
            this.tagImageUrl = response.data.url;
          }
        } catch (error) {
          console.log(error);
          await oneBtnDialog('태그 이미지 업로드 실패', '태그 이미지 업로드에 실패하였습니다.', false);
        }
      }
    },

    // rgba코드 hex코드로 바꾸기
    convertToHex() {
      const rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/;
      const matches = this.pureColor.match(rgbaRegex);
      if (matches) {
        const r = parseInt(matches[1]);
        const g = parseInt(matches[2]);
        const b = parseInt(matches[3]);
        const a = matches[4] ? parseFloat(matches[4]) : 1;

        const toHex = (dec) => {
          const hex = dec.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        };
        const hexR = toHex(r);
        const hexG = toHex(g);
        const hexB = toHex(b);
        const hexA = toHex(Math.round(a * 255));
        this.hexValue = `#${hexR}${hexG}${hexB}${hexA}`.substring(0, 7); // 7자리까지만 추출
        this.background_color = this.hexValue;
      } else {
        this.hexValue = ''; // 유효하지 않은 값인 경우에는 빈 문자열로 설정
        this.background_color = '';
      }
    },
    convertDate(dateString) {
      if(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}/${month}/${day}`;
      } else {
          return `-`;
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/common-css.scss';
.row {
    padding: 28px 28px 72px 28px !important;
}
.ant-btn {
    border-radius: 6px;
}
.ant-switch{
    border-radius: 100px;
}
.ant-btn-default {
    background-color: #e8ebed;
    border: none;
    box-shadow: none;
}
input[type=file] {
    opacity: 0;
    position: absolute;
}
.ant-btn.black {
    background-color: #4B5158;
    color: white;
}

.ant-btn-primary {
    background-color: #ffe414;
}
.ant-btn {
    color: #17191C;
    height: 40px;
    box-shadow: none !important;
    transition: ease-in-out 0.3s;
    padding: 13px 18px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    transition: ease-in-out 0.3s;
}
.ant-btn{
  p{
    margin-bottom: 0;
  }
}
/* 인증서 기본 템플릿 섹션 스타일 */
.template-section {
  margin-top: 24px;
  margin-bottom: 8px;
  padding-top: 24px;
  border-top: 1px solid #e8ebed;
}
.template-section-header {
  margin-bottom: 8px;
}
.template-section-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #17191C;
  margin-bottom: 4px;
}
.template-section-desc {
  font-size: 13px;
  color: #6B7280;
  margin-bottom: 0;
}
.template-textarea {
  min-height: 100px;
  resize: vertical;
}

/* 태그 이미지 미리보기 스타일 */
.tag-preview-wrap {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e8ebed;
}
.tag-preview-image {
  max-width: 56px;
  max-height: 28px;
  object-fit: contain;
}

/* 태그 표시 순서 힌트 스타일 */
.display-order-hint {
  font-size: 13px;
  color: #6B7280;
}

@media screen and (max-width:767px) {
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }

  .file-input-wrap,
  .file-input-wrap .file-relative-wrap,
  .content-wrap-card .inputDiv{
    display: flex;
    flex-direction: column;
  }

  .item-btn-area,
  .content-wrap-card .inputDiv,
  .colorPicker,
  .file-input-wrap,
  .property-area,
  .content-wrap-card .inputDiv .input-textarea-common,
  .content-wrap-card .inputDiv .input-text-common{
    width: 100% !important;
    max-width: none;
  }
}
</style>